import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { TStore } from "models";
import {
	getInternalLinkActivation,
	getLinkPreviewState,
	getMembersiteInternalRoute,
	getSafeExternalUrl,
	LinkPreview,
} from "../previewPostLink/linkPreviewModel";
import styles from "./styles.module.scss";

interface IPreviewLinkCard {
	preview: LinkPreview;
}

const PreviewLinkCard: React.FunctionComponent<IPreviewLinkCard> = ({
	preview,
}) => {
	const navigate = useNavigate();
	const currentCommunityId = useSelector(
		(state: TStore) => state.app.currentCommunityId,
	);
	const [imageFailed, setImageFailed] = useState(false);
	const visiblePreview = {
		...preview,
		image: imageFailed ? null : preview.image,
	};
	const state = getLinkPreviewState(visiblePreview);
	const internalActivation =
		state === "internal" ? getInternalLinkActivation(preview.route) : null;
	const internalRoute = internalActivation
		? getMembersiteInternalRoute(internalActivation, currentCommunityId)
		: null;
	const safeHref = getSafeExternalUrl(preview.url);

	useEffect(() => setImageFailed(false), [preview.image]);

	if (state === "loading") {
		return (
			<div className={styles.card} aria-label="Loading link preview">
				<div className={styles.skeletonImage} />
				<div className={styles.content}>
					<div
						className={`${styles.skeletonLine} ${styles.shortLine}`}
					/>
					<div
						className={`${styles.skeletonLine} ${styles.titleLine}`}
					/>
					<div className={styles.skeletonLine} />
				</div>
			</div>
		);
	}

	if (state === "fallback") {
		return null;
	}

	const body = (
		<>
			{state === "full" && visiblePreview.image ? (
				<img
					src={visiblePreview.image}
					className={styles.image}
					alt=""
					onError={() => setImageFailed(true)}
				/>
			) : null}
			<div className={styles.content}>
				<div
					className={`${styles.domain} ${
						state === "internal" ? styles.internal : ""
					}`}
				>
					{state === "internal"
						? "IN THIS COMMUNITY"
						: preview.domain}
				</div>
				{preview.title ? (
					<div className={styles.title}>{preview.title}</div>
				) : null}
				{preview.description ? (
					<div className={styles.description}>
						{preview.description}
					</div>
				) : null}
			</div>
		</>
	);

	if (internalRoute) {
		return (
			<button
				type="button"
				className={`${styles.card} ${styles.button}`}
				onClick={() => navigate(internalRoute)}
			>
				{body}
			</button>
		);
	}

	return safeHref ? (
		<a
			className={styles.card}
			href={safeHref}
			target="_blank"
			rel="noopener noreferrer"
		>
			{body}
		</a>
	) : null;
};

export default PreviewLinkCard;
